// Tracks the user's latest-generated advisor plan so drill-in subpages
// survive a navigate-and-return. Persisted to sessionStorage so it lives
// across reloads in the same tab/session but doesn't pollute the next visit.
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface PlanState {
  currentPlanId: string | null;
  setCurrentPlanId: (id: string | null) => void;
}

export const usePlanStore = create<PlanState>()(
  persist(
    (set) => ({
      currentPlanId: null,
      setCurrentPlanId: (id) => set({ currentPlanId: id }),
    }),
    {
      name: 'spent_tracker.currentPlan',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
